/**
 * L2-P3: moved to @miq/platform (services/user.service.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform'.
 */
export { UserService } from '@miq/platform';
